<template>
  <div>
    <app-cells><h1 class="title">Taxes</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FinanceTaxesLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-taxes', label: 'Taxes'},
        { name: 'finance-taxes-vat', label: 'VAT statement'},
      ],
    }
  },
}
</script>
